import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    prepareSelectOptionsList,
    actionsFormatter,linkFormatter,
    historyDataFormatter,
    dateFormatter,
    customFormatter,
    getFieldByPathFormatter
} from 'util/Utils';

 
import config from  '../../../config';
import {
    UPDATE_ADMIN_PRODUCT, DELETE_ADMIN_PRODUCT, ADD_SELECTED_PRODUCTS,
    REMOVE_SELECTED_PRODUCTS
} from "actions/actionTypes";
import moment   from 'moment'
class  KPIReportsTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            currentRecord: {},

        };

    }


    render() {

        return (
            <div className="top20 contractor-statistics-table databases-table">
                <BootstrapTable data={this.props.KPIReportData} ref='table'
                                remote={ true }
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } }

                >
                    <TableHeaderColumn width="35px" dataAlign="center" dataField='Title'
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['Title'], format: (value) => {

                            return <span className='blue text-bold' >{value}</span>
                        }
                    }} editable={ false } dataSort={false}>Title</TableHeaderColumn>
                    <TableHeaderColumn width="35px" dataAlign="center" dataField='Value'
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['Value'], format: (value) => {

                            return value
                        }}}
                                       editable={ false } dataSort={false}>Data</TableHeaderColumn>
                    <TableHeaderColumn dataField="Title" isKey={true} hidden={true} autoValue={ true }
                    >Id</TableHeaderColumn>

                </BootstrapTable>

            </div>
        );
    }
}

export default KPIReportsTable;
